module.exports = __webpack_public_path__ + "static/media/payment-sent.8dfa05aa.svg";